// App
import { BaseStore } from "../../../Core/Stores/BaseStore";
import { action, observable } from "mobx";
import { Stores } from "../Stores";
import { InitialState } from "Custom/Models";

export class ErrorStore extends BaseStore {
    @observable public hasError: boolean = false;
    @observable public title: string = "";
    @observable public errorMessage1: string = "";
    @observable public errorMessage2: string = "";

    /*     @observable public hasError: boolean = true;
    @observable public title: string = "Test";
    @observable public errorMessage1: string = "This is an error message";
    @observable public errorMessage2: string = "This is the secondary error message"; */

    public constructor() {
        super();
    }

    public init(stores: Stores, initialState: InitialState) {}

    @action
    public Close = (): void => {
        this.errorMessage1 = "";
        this.errorMessage2 = "";
        this.hasError = false;
    };

    @action
    public SetErrorMessage = (title: string, line1: string, line2: string): void => {
        this.title = title;
        this.errorMessage1 = line1;
        this.errorMessage2 = line2;
        this.hasError = true;
    };
}
